module.exports = '4.12.0';



// WEBPACK FOOTER //
// ./src/version.js